import React, { useEffect, useState } from "react";
import { getCurrentUserAccessLevel } from "../utils/getCurrentUseAccessLevel";
import { jwtDecode } from "jwt-decode";

const RequirePermission = ({ subModuleName, minAccessLevel, children }) => {
  const [hasPermission, setHasPermission] = useState(false);
  
  const mirror = localStorage.getItem("mirror");
  const token = localStorage.getItem("accessToken");
  const role = jwtDecode(token).role;
  const type = jwtDecode(token).user_type;
  
  useEffect(() => {

    const verify = () => {
      if (role !== 'user' || type === 'administrator') {
        setHasPermission(true);
      }
      else {
        if (getCurrentUserAccessLevel(subModuleName) >= minAccessLevel) {
          setHasPermission(true);
        } else {
          setHasPermission(false);
        }
      }
    };

    if (mirror) {
      verify();
    } else {
      setHasPermission(true);
    }
  }, [mirror]);
  return hasPermission ? children : null;
};

export default RequirePermission;
